module.exports = __webpack_public_path__ + "static/img/4bg_11.cac4daf.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/4bg_11.png
// module id = 696
// module chunks = 1